import { CreateAvatarModal } from '@/pages/avatar';
import styled from '@emotion/styled';
import { CreateAvatar } from './CreateAvatar';
import { GenerateFromText } from './GenerateFromText';
import { Search } from './Search';

const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
`;

const Buttons = styled.div`
    display: flex;
    gap: 16px;
`;

export const Header = () => {
    return (
        <>
            <HeaderContainer>
                <Search />

                <Buttons>
                    <GenerateFromText />
                    <CreateAvatar />
                </Buttons>
            </HeaderContainer>
            <CreateAvatarModal from="avatars-page" />
        </>
    );
};
